import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent, FriendlyCaptchaComponent } from '@catch/general-ui';
import { ToastsService } from '@catch/services';
import { TranslocoPipe } from '@jsverse/transloco';
import { emailRegex } from '../../../../../../assets/regex';
import { PlatformAuthService } from '../../../../services/platform-auth.service';

@Component({
  selector: 'app-platform-reset-password-form',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslocoPipe, ButtonComponent, FriendlyCaptchaComponent],
  templateUrl: './platform-reset-password-form.component.html',
  styleUrl: './platform-reset-password-form.component.scss',
})
export class PlatformResetPasswordFormComponent {
  private readonly toastsService = inject(ToastsService);
  private readonly fb = inject(FormBuilder);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly auth = inject(PlatformAuthService);

  readonly resetPasswordForm: FormGroup = this.fb.group({
    email: this.fb.control(null, [Validators.pattern(emailRegex), Validators.required]),
    captcha: this.fb.control(null, [Validators.required]),
  });
  resetPasswordFormSubmitAttempt = false;
  resetPasswordFormSubmitting = false;
  readonly resetPasswordSuccess = signal(false);

  /**
   * Submits the password reset form.
   */
  onResetPasswordFormSubmit(): void {
    this.resetPasswordFormSubmitAttempt = true;
    if (this.resetPasswordForm.valid) {
      this.resetPasswordFormSubmitting = true;
      this.auth.requestPasswordReset(this.email.value, this.captchaCode.value ?? '').subscribe({
        next: () => {
          this.toastsService.success('jobboard.platform.auth.reset-password.success-toast');
          this.resetPasswordSuccess.set(true);
          this.resetPasswordFormSubmitAttempt = false;
          this.resetPasswordFormSubmitting = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.resetPasswordFormSubmitting = false;
          this.captchaCode.setValue(null);
          this.toastsService.warning('jobboard.platform.auth.reset-password.error');
          this.cdr.markForCheck();
        },
      });
    }
  }

  get email() {
    return this.resetPasswordForm.get('email')!;
  }

  get captchaCode() {
    return this.resetPasswordForm.get('captcha') as FormControl<string | null>;
  }
}
